import React from 'react';
import Loader from 'src/components/loader';
import loadable from '@loadable/component';
import expertGuideQuery from './query.graphql';

const ExpertGuide = loadable(
  () => import(/* webpackChunkName: "expert" */ './guide'),
  {
    fallback: <Loader />,
  }
);

ExpertGuide.graphQL = expertGuideQuery;

ExpertGuide.variables = ({ slug }) => ({
  slug,
});

export default ExpertGuide;
